/* Ejemplo no utilizado */
import React from 'react'

// #region CSS
import { makeStyles } from '@material-ui/core/styles'
import Fade from '@material-ui/core/Fade'
import Grid from '@material-ui/core/Grid'
import Typography from '@material-ui/core/Typography'
import Box from '@material-ui/core/Box'
const useStyles = makeStyles(theme => ({
  root: {
    marginTop: '30px',
    display: 'flex'
  }
}))
// #endregion

export default function Example(props) {
  const classes = useStyles()
  return (
    <div className={classes.root}>
      <Grid container spacing={2} justify='center' alignItems='center'>
        <Fade in={true} timeout={1000}>
          <Grid
            container
            justify='center'
            alignItems='center'
            item
            xs={12}
          >
            <Grid item xs={12}>
              <Box textAlign='center'>
                <Typography data-lang="privacy_title" color='secondary' variant='h4'>
                  <u>POLÍTICA DE PRIVACIDAD</u>
                </Typography>
              </Box>
            </Grid>
            <Grid
              container
              justify='flex-start'
              alignItems='flex-start'
              item
              xs={11}
              lg={9}
              className='mt-3'
            >
              <div className='container-legal'>
                <p data-lang-html="privacy_intro">
                  SOLERA 1900, S.L. (en adelante, ILUSIONA) tiene como objetivo respetar la privacidad de sus usuarios y proteger los datos de carácter personal que éstos puedan facilitar a ILUSIONA.
                </p>
                <p data-lang-html="privacy_law_reference">
                  En respeto a la Ley Orgánica 3/2018, de 5 de diciembre, de Protección de Datos Personales y garantía de los derechos digitales (en adelante, LOPDGDD) y el Reglamento General de Protección de Datos de la Unión Europea (en adelante, RGPD), esta labor de recopilación de los datos se regirá a partir de los términos descritos a continuación:
                </p>
                <br />
                <p data-lang-html="privacy_responsible_heading">
                  <strong>
                    <u>
                      Información sobre el responsable del tratamiento, la recopilación, finalidad, legitimación y tiempo de conservación de los datos de carácter personal
                    </u>
                  </strong>
                </p>
                <p data-lang-html="privacy_responsible_content">
                  En la presente política de privacidad se encuentra toda la información sobre los tratamientos de datos de carácter personal que ILUSIONA realiza sobre los datos del usuario. Como muestra de compromiso con la normativa de protección de datos, ILUSIONA pone a disposición del usuario, de manera permanente, la información relativa a nuestra política de privacidad en la presente website.
                </p>
                <div data-lang-html="privacy_company_info" style={{ border: '1px solid #000', padding: '10px', margin: '10px 0' }}>
                  <p>
                    SOLERA 1900, S.L. (en adelante, ILUSIONA)<br />
                    NIF: B-63.294.565<br />
                    Calle General Diaz Porlier, 14, Bajos, Puerta 3ª<br />
                    Madrid (28001 - Madrid)<br />
                    <a href='https://club.ilusiona.com' target='_blank' rel='noopener noreferrer'>club.ilusiona.com</a><br />
                    <a href='mailto:rgpd@ilusiona.com'>rgpd@ilusiona.com</a>
                  </p>
                </div>
                <p data-lang-html="privacy_consent">
                  El usuario consiente expresa e inequívocamente que aquellos
                  datos de carácter personal que facilite sean incorporados a
                  nuestros ficheros, así como su tratamiento automatizado, o no,
                  con la finalidad de gestionar el motivo de su contacto, darle
                  trámite a nivel administrativo, gestionar el alta y gestión en
                  el club ilusiona, así como con el objeto de remitirle
                  comunicaciones comerciales, promocionales o publicitarias,
                  incluidas las relativas al CLUB ILUSIONA. Dichos ficheros se
                  encuentran debidamente inscritos en la Agencia Española de
                  Protección de Datos conforme a la legislación vigente y
                  normativa de desarrollo.
                </p>
                <p data-lang-html="privacy_retention">
                  Así mismo, se comunica a los usuarios que los datos de
                  carácter personal serán conservados hasta que hayan dejado de
                  ser necesarios o pertinentes para la finalidad por los que
                  fueron recabados o registrados en nuestros ficheros.
                  Posteriormente, los datos de carácter personal que cumplan
                  esta condición, serán cancelados, a no ser que haya una norma
                  de rango legal que habilite su conservación. Destacar que los
                  datos de carácter personal serán cancelados cuando el usuario
                  haya ejercido el derecho de cancelación de los mismos.
                </p>
                <br />
                <p data-lang-html="privacy_transfer_heading">
                  <strong>Cesión de datos</strong>
                </p>
                <p data-lang-html="privacy_transfer_content">
                  La aceptación de esta política implica que el usuario expresa
                  e inequívocamente consienta que los datos que ILUSIONA hayan
                  podido recopilar e incluir en los ficheros mencionados sean
                  cedidos o comunicados a las empresas asociadas del GRUPO
                  ILUSIONA, que, por otra parte, aparecen referenciadas en la
                  página web, así como a las demás empresas colaboradoras con
                  las mismas finalidades para los que han sido recabados.
                </p>
                <br />
                <p data-lang-html="privacy_rights_heading">
                  <strong>Derechos de los usuarios</strong>
                </p>
                <p data-lang-html="privacy_rights_content">
                  El usuario o su representante, legal o voluntario, acreditando su identidad, así como el poder de representación oportuno, podrán ejercer los derechos descritos anteriormente dirigiendo una comunicación por escrito a la dirección de correo electrónico{' '}
                  <a href='mailto:rgpd@ilusiona.com'>rgpd@ilusiona.com</a>.
                </p>
                <p data-lang-html="privacy_rights_claim">
                  El usuario tiene derecho a presentar una reclamación ante la{' '}
                  <a href='https://www.agpd.es/portalwebAGPD/index-ides-idphp.php'>
                    Agencia Española de Protección de Datos
                  </a>{' '}
                  si considera que se vulneran los derechos anteriormente
                  expuestos en la presente política de privacidad o si considera
                  que el tratamiento de datos personales que le conciernen
                  infringe el Reglamento (UE) 2016/679 del Parlamento Europeo y
                  del Consejo, de 27 de abril de 2016, la Ley Orgánica 3/2018,
                  de 5 de diciembre, de Protección de Datos Personales y garantía de los derechos digitales y su Reglamento de desarrollo.
                </p>
                <br />
                <p data-lang-html="privacy_security_heading">
                  <strong>
                    Seguridad aplicada a los datos de carácter personal
                  </strong>
                </p>
                <p data-lang-html="privacy_security_content">
                  Con el objeto de garantizar la seguridad e integridad de los
                  datos facilitados que sean de carácter personal, ILUSIONA ha
                  adoptado las medidas técnicas y organizativas necesarias con
                  el objetivo de evitar la pérdida de los datos, el tratamiento
                  o el acceso no autorizado de terceros tal y como estipula la
                  legislación vigente en la materia y habida cuenta del estado
                  de la tecnología y la naturaleza de los datos almacenados.
                </p>
                <br />
                <p data-lang-html="privacy_social_heading">
                  <strong>Redes Sociales</strong>
                </p>
                <p data-lang-html="privacy_social_content">
                  ILUSIONA actualmente está presente en alguna de las
                  principales redes sociales: Facebook, Twitter, Google +,
                  Youtube y Pinterest . Por este motivo asume el papel de
                  Responsable del Tratamiento de los Datos vertidos en sus
                  perfiles derivado de los amigos, me gusta, followers o
                  seguidores, comentarios…
                </p>
                <p data-lang-html="privacy_social_disclaimer">
                  El usuario acepta expresamente estar sometido a las
                  condiciones y términos que, en materia de privacidad, disponen
                  las distintas redes sociales o plataformas donde la Bolera
                  está presente, facultando a ésta a utilizar los medios que las
                  mismas redes le permite para poder informar a los usuarios
                  sobre las diferentes actividades y servicios que realiza.
                </p>
                <br />
                <p data-lang-html="privacy_modifications_heading">
                  <strong>Modificaciones</strong>
                </p>
                <p data-lang-html="privacy_modifications_content">
                  La presente Política de Privacidad podrá ser actualizada en
                  cualquier momento en base a las necesidades propias de la{' '}
                  <i>website</i> y futuros cambios legislativos en materia de
                  privacidad, reservándose ILUSIONA este derecho en exclusiva.
                </p>
                <br />
                <p data-lang-html="privacy_contact_content">
                  <b>Contacto con ILUSIONA</b>
                  <br />
                  Calle General Diaz Porlier, 14, Bajos
                  <br />
                  Madrid (28001)
                  <br />
                  <a href='mailto:rgpd@ilusiona.com'>
                    <span id='et-info-email'>rgpd@ilusiona.com</span>
                  </a>
                </p>
              </div>
            </Grid>
          </Grid>
        </Fade>
      </Grid>
    </div>
  )
}
